var _a;
import React from "react";
import { useRightholderEarnings } from "frontend/src/domain/rightholder-earning";
import { usePagination } from "frontend/src/lib/pagination";
export var PaidStatus;
(function (PaidStatus) {
    PaidStatus[PaidStatus["any"] = 0] = "any";
    PaidStatus[PaidStatus["paid"] = 1] = "paid";
    PaidStatus[PaidStatus["nonPaid"] = 2] = "nonPaid";
})(PaidStatus || (PaidStatus = {}));
var paidStatusToSearchMap = (_a = {},
    _a[PaidStatus.any] = undefined,
    _a[PaidStatus.paid] = true,
    _a[PaidStatus.nonPaid] = false,
    _a);
var useDateInput = function () {
    var _a = React.useState(""), date = _a[0], setDate = _a[1];
    var onChange = function (evt) {
        setDate(evt.target.value);
    };
    return {
        value: date,
        onChange: onChange,
    };
};
var usePaidStatus = function () {
    var _a = React.useState(PaidStatus.nonPaid), paidStatus = _a[0], setPaidStatus = _a[1];
    var onChange = function (evt) {
        var value = evt.target.value;
        if (value === PaidStatus.paid ||
            value === PaidStatus.nonPaid ||
            value === PaidStatus.any) {
            setPaidStatus(value);
        }
    };
    return {
        value: paidStatus,
        onChange: onChange,
    };
};
export var usePage = function () {
    var startDate = useDateInput();
    var endDate = useDateInput();
    var paidStatus = usePaidStatus();
    var _a = usePagination({
        page: 0,
        rowsPerPage: 25,
        pageResetDeps: [startDate.value, endDate.value, paidStatus.value],
    }), page = _a.page, rowsPerPage = _a.rowsPerPage, onChangeRowsPerPage = _a.onChangeRowsPerPage, onChangePage = _a.onChangePage, skip = _a.skip;
    var earnings = useRightholderEarnings({
        startDate: startDate.value,
        endDate: endDate.value,
        mine: true,
        isPaid: paidStatusToSearchMap[paidStatus.value],
        skip: skip,
        take: rowsPerPage,
    });
    return {
        earnings: earnings,
        startDate: startDate,
        endDate: endDate,
        paidStatus: paidStatus,
        pagination: { page: page, rowsPerPage: rowsPerPage, onChangeRowsPerPage: onChangeRowsPerPage, onChangePage: onChangePage },
    };
};
